module.exports = __webpack_public_path__ + "static/media/icon-fb.59c8de2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-fb.svg
// module id = 401
// module chunks = 2